import { Container } from '../Container';
import { Logo } from '@/components/shared/atoms/Logo';
import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="border-t border-gray-200 bg-gray-50 mt-20">
      <Container>
        <div className="py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <Logo className="mb-4" />
            <p className="text-gray-600 text-sm">
              Premium gaming controllers for competitive and casual gamers.
            </p>
          </div>

          {/* Shop */}
          <div>
            <h3 className="text-gray-900 font-semibold mb-4">Shop</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/shop" className="text-gray-600 hover:text-brand-primary transition-colors">
                  All Products
                </Link>
              </li>
              <li>
                <Link to="/shop?category=PadBox" className="text-gray-600 hover:text-brand-primary transition-colors">
                  PadBox
                </Link>
              </li>
              <li>
                <Link to="/shop?category=Hing3DBox" className="text-gray-600 hover:text-brand-primary transition-colors">
                  Hing3DBox
                </Link>
              </li>
              <li>
                <Link to="/shop?category=Accessories" className="text-gray-600 hover:text-brand-primary transition-colors">
                  Accessories
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-gray-900 font-semibold mb-4">Support</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/downloads" className="text-gray-600 hover:text-brand-primary transition-colors">
                  Downloads
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-600 hover:text-brand-primary transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/shipping" className="text-gray-600 hover:text-brand-primary transition-colors">
                  Shipping Policy
                </Link>
              </li>
              <li>
                <Link to="/refund" className="text-gray-600 hover:text-brand-primary transition-colors">
                  Refund Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-gray-900 font-semibold mb-4">Contact</h3>
            <ul className="space-y-2">
              <li className="text-gray-600">
                Support coming soon
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 py-6">
          <p className="text-center text-gray-500 text-sm">
            © {new Date().getFullYear()} Arkodd. All rights reserved.
          </p>
        </div>
      </Container>
    </footer>
  );
};
